import { ReadStbGroupsRequest, StbGroupRequest } from '@openapi';
import { StbGroup, Device } from '@services/types';
import { getStbGroupsApi } from './configuration';

const stbGroups = {
  createStbGroup: (stbGroup: StbGroupRequest, makeDefault: boolean) => {
    return getStbGroupsApi().createStbGroup({ stbGroupRequest: stbGroup, makeDefault: makeDefault });
  },
  updateStbGroup: (stbGroup: StbGroupRequest & { id: StbGroup['id'] }) => {
    return getStbGroupsApi().updateStbGroup({ id: stbGroup.id, stbGroupRequest: stbGroup });
  },
  // getStbGroupFirmware: (stbGroupId: StbGroup['id']) => {
  //   return getStbGroupsApi().readStbGroupFirmwares({ id: stbGroupId });
  // },
  deleteStbGroup: (stbGroupId: StbGroup['id']) => {
    return getStbGroupsApi().deleteStbGroup({ id: stbGroupId });
  },
  getStbGroups: (requestParameters?: ReadStbGroupsRequest) => {
    return getStbGroupsApi().readStbGroups(requestParameters);
  },
  getStbGroupsFilter: () => {
    return getStbGroupsApi().readNamesIdsStbGroups();
  },
  getStbGroupsById: (stbGroupId: StbGroup['id']) => {
    return getStbGroupsApi().readStbGroup({ id: stbGroupId });
  },
  moveDevices: (stbGroupId: StbGroup['id'], ids: Device['id'][]) => {
    return getStbGroupsApi().moveDevices({ id: stbGroupId, requestBody: ids });
  },
};

export default stbGroups;
